<template>
  <div>
    <section id="content">
      <div class="container">
        <br />

        <!-- NEW COMPONENT HERE -->
        <input
          type="text"
          class="input is-medium has-text-centered"
          style="margin: 0 1rem;"
          v-model="secure"
          placeholder="Enter Type"
          v-if="secure != 'copae-caddy'"
        />
        <br />
        <div class="filter is-mobile has-text-centered" v-if="secure == 'copae-caddy'">
          <h2>Search Form</h2>

          <div class="field">
            <p class="control" style="display: flex;">
              <input
                type="text"
                class="input is-medium"
                style="margin: 0 1rem;"
                v-model="startDate"
                @change="submit"
                placeholder="Enter Start Date"
              />
              <input
                type="text"
                class="input is-medium"
                style="margin: 0 1rem;"
                v-model="endDate"
                @change="submit"
                placeholder="Enter End Date"
              />

              <input
                type="text"
                class="input is-medium"
                style="margin: 0 1rem;"
                v-model="form_code"
                @change="submit"
                placeholder="Enter Form Code"
              />

              <label class="checkbox" style="white-space: nowrap; padding: .75rem;">
                <input type="checkbox" v-model="deliveries" @change="submit" />
                <span style="white-space: nowrap">Deliveries Only</span>
              </label>
            </p>
          </div>
        </div>

        <div class="summary" v-if="secure == 'copae-caddy'">
          <small class="rowCount">
            Showing
            <b>{{ items.length }}</b> records
            <template>
              <label>
                between
                <strong>{{ startDate }} and {{ endDate }}</strong>
              </label>
            </template>
          </small>
        </div>

        <table
          id="results-table"
          class="rtable rtable--flip"
          style="display: block !important;"
          v-if="secure == 'copae-caddy'"
        >
          <thead>
            <tr>
              <th class="orderdate">Order Date</th>
              <th class="address">Address</th>
              <th class="contactno">Contact No</th>
              <th class="email">Email</th>
              <th class="firstname">Name</th>
              <th class="pickup">Bags</th>
              <th class="pickup">Caddy</th>
              <th class="comment">Comment</th>
              <th class="propertyDescription">Property Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="submission in items" :key="submission.id">
              <td>{{ submission.orderDate }}</td>
              <td>{{ submission.address }}</td>
              <td>{{ submission.contactNumber }}</td>
              <td>{{ submission.email }}</td>
              <td>{{ submission.firstName }} {{ submission.lastName }}</td>
              <td>
                <template v-if="submission.binsRequired.indexOf('Kitchen Bags') >= 0">
                  <template
                    v-if="submission.bagPickup == '' || submission.bagPickup == 'Deliver' && submission.binsRequired.indexOf('Kitchen Bags') >= 0 "
                  >
                    <strong style="color: green;">Deliver</strong>
                  </template>
                  <template v-else>
                    <span style="color: #ff9898;">{{ submission.bagPickup }}</span>
                  </template>
                </template>
                <template v-else>-</template>
              </td>
              <td>
                <template v-if="submission.binsRequired.indexOf('Kitchen Caddy') >= 0">
                  <template
                    v-if="submission.caddyPickup == '' || submission.caddyPickup == 'Deliver' && submission.binsRequired.indexOf('Kitchen Caddy') >= 0 "
                  >
                    <strong style="color: green;">Deliver</strong>
                  </template>
                  <template v-else>
                    <span style="color: #ff9898;">{{ submission.caddyPickup }}</span>
                  </template>
                </template>
                <template v-else>-</template>
              </td>
              <td>{{ submission.comment }}</td>
              <td>{{ submission.propertydescription }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {},

  data() {
    return {
      items: [],
      itemCount: 0,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      today: moment(new Date()).format("YYYY-MM-DD"),
      form_code: "REQ.BIN.NEW.CADDY",
      secure: "",
      deliveries: false,
      //maxAmount: 1000,
      loading: false,
      error: false
    };
  },

  props: {
    index: { default: 0 },
    grouptype: {}
  },

  mounted() {
    // this.getSubmissions();
  },

  computed: {},

  methods: {
    getSubmissions: function() {
      axios
        .get("/api/submissions", {
          params: {
            start: this.startDate,
            end: this.endDate,
            form_code: this.form_code,
            deliveries: this.deliveries
          }
        })
        .then(response => {
          this.items = response.data;
        });
    },

    submit: function() {
      this.getSubmissions();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/FormSubmissionReportCaddy.vue